"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useDetailedProductsList", {
  enumerable: true,
  get: function () {
    return _useDetailedProductsList.default;
  }
});

var _useDetailedProductsList = _interopRequireDefault(require("./useDetailedProductsList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }